import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5fdb294"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: ''
  },
  height: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props


const iconName = computed(() => `#icon-${ props.name }`)
const svgClass = computed(() => {
  if (props.name) return `svg-icon icon-${ props.name }`
  return 'svg-icon'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({ class: _unref(svgClass) }, _ctx.$attrs, {
    style: { color: __props.color, width: __props.width, height: __props.height }
  }), [
    _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
  ], 16))
}
}

})